<template>
  <div>
    <!-- <detailHeader /> -->
    <!-- 列表 -->
    <el-dialog :title="$t('message.directPacking')" :visible.sync="$parent.directPackingDialogVisible" width="1860px"
      :close-on-click-modal="false" center>
      <div class="encasementDetail">
        <div class="table">
          <ol>
            <!-- 选择 -->
            <li class="flex05">{{ $t("message.choose") }}</li>
            <!--  番号-->
            <li>
              {{ $t("message.mash") }}
            </li>
            <!--照片-->
            <li>
              {{ $t("message.pic") }}
            </li>
            <!-- 业务编辑商品属性 -->
            <li class="flex15">{{ $t("message.theBusinessEditsTheCommodityProperties") }}</li>
            <!--交易号数量  -->
            <li>{{ $t("message.numberOfTransactionNumbers") }}</li>
            <!-- 本次到货数 -->
            <li>{{ $t("message.numberOfArrivalsThisTime") }}</li>
            <!--已加检品单数  -->
            <li>{{ $t("message.theNumberOfItemsThatHaveBeenInspected") }}</li>
            <!-- 价格 -->
            <li>{{ $t("message.price") }}</li>
            <!-- 检品问题数 -->
            <li>{{ $t("message.numberOfInspectionProblems") }}</li>
            <!-- 问题产品数 -->
            <li>{{ $t("message.numberOfProblemProducts") }}</li>
          </ol>
          <!-- 无数据显示 -->
          <div class="noData" v-if="tableData == false">暂无数据</div>
          <!-- 订单详情 -->
          <div class="itemDetail" v-for="(item, index) in tableData" :key="index" @click="getboxData(item, index)">
            <div class="head">
              <!-- 是否显示 -->
              <div class="show" @click="isShow(index)">
                <i class="el-icon-arrow-down" v-if="!item.show"></i>
                <i class="el-icon-arrow-up" v-else></i>
              </div>
              <!-- 订单号 -->
              <div class="item">
                <p>
                  <b style="color: #2C96E7;"> {{ item.user.authorized == 1 ? '[授权]' : '' }} </b>
                  <router-link :to="'orderPaymentDetail?order_sn=' + item.order_sn" target="_blank" class="a-link">
                    {{ item.order_sn }}
                  </router-link>
                </p>
                <p>{{ item.user.realname }}</p>
              </div>
              <!-- 交易号  -->
              <div class="item" style="line-height: 20px">
                <span>
                  {{ $t("message.transactionNumber") }}：
                  <a href="javascript:;" class="a-link">
                    {{ item.purchase_no }}</a>
                </span>
                <!-- 物流号 -->
                <p>
                  {{ $t("message.logisticsNumber") }}：
                  <a href="javascript:;" class="a-link">
                    {{
                      item.order_purchase_express != false
                        ? item.order_purchase_express[0].express_no
                        : "-"
                    }}
                    <el-tooltip placement="top" v-if="item.order_purchase_express != false">
                      <div slot="content">
                        <p v-for="(items, indexs) in item.order_purchase_express" :key="indexs">
                          {{ $t("message.logisticsNumber") }}{{ index + 1 }}：
                          {{ items.express_no }}
                        </p>
                      </div>
                      <el-button size="mini" type="primary" icon="el-icon-search"
                        class="express_no-list primary"></el-button>
                    </el-tooltip>
                  </a>
                </p>
              </div>
              <div class="item name">
                <!-- 业务 -->
                <span>{{ $t("message.business") }}：{{ item.y_name }}</span>
                <!--  采购-->
                <span>{{ $t("message.purchase") }}：{{ item.g_name }}</span>
                <!-- 配货 -->
                <span>{{ $t("message.distribution") }}：{{ item.p_name }}</span>
              </div>
              <!-- 查看备注 -->
              <div class="lookRemark item">
                <!-- 打印包裹信息 -->
                <el-button type="success" size="small" class="primary" @click="printPackageInformation(item)">
                  {{ $t("message.printPackageInformation") }}</el-button>
                <!-- 打印客户信息 -->
                <el-button type="success" size="small" class="primary" @click="printCustomerInformation(item)">
                  {{ $t("message.printCustomerInformation") }}</el-button>
                <!-- <el-button type="primary" @click="lookRemark(item)" style="background: #fa5058" size="small">
                RK{{ $t("message.orderNotes") }}</el-button> -->
              </div>
            </div>
            <!--  -->
            <ul v-for="(items, indexs) in item.list" :key="indexs" v-show="!item.show">
              <!-- 选择 -->
              <li class="flex05">
                <label>
                  <el-checkbox v-model="items.checked" @change="changeItem"></el-checkbox>
                </label>
              </li>
              <!--   番号-->
              <li>
                {{ items.sorting }}
              </li>
              <!--照片-->
              <li>
                <div>
                  <div class="img">
                    <el-popover placement="right" width="300" trigger="hover">
                      <img :src="items.pic" alt="" style="width: 300px; height: 300px" />
                      <a :href="items.origin_link" target="_blank" slot="reference">
                        <img :src="items.pic" alt="" />
                      </a>
                    </el-popover>
                  </div>
                </div>
              </li>
              <!-- 业务编辑商品属性 -->
              <li class="flex15">
                <div class="template">
                  <p v-for="(skuItem, skuIndex) in items.detail_y" :key="skuIndex">
                    <span>{{ skuItem.key }}:</span>
                    <span>{{ skuItem.value }}</span>
                  </p>
                </div>
              </li>
              <!-- 交易号数量  -->
              <li>
                <div class="template">
                  <div>
                    <!-- 可入库 -->
                    <p>
                      {{ $t("message.canBePutIntoStorage") }}:{{
                        items.possible_num
                      }}
                    </p>
                    <!-- 已到货 -->
                    <p>
                      {{ $t("message.itHasArrived") }}:{{ items.storage_num }}
                    </p>
                    <!-- 在库 -->
                    <p>{{ $t("message.inStock") }}:{{ items.stock_num }}</p>
                  </div>
                </div>
              </li>

              <!-- 本次到货数 -->
              <li>
                <el-input v-model="items.maxUpNum" @input="minMaxNum(index, indexs, items)" type="number"
                  onfocus="this.select()" onkeyup.native="value=value.replace(/^(0+)|[^\d]+/g,'')"></el-input>
              </li>
              <!--已加检品单数  -->
              <li>{{ items.inspectNum }}</li>
              <!-- 价格 -->
              <li>{{ items.confirm_price }}</li>
              <!-- 检品问题数 -->
              <li>无</li>
              <!-- 问题产品数 -->
              <li>
                <div class="template">
                  <!--  数量差 -->
                  <p>
                    {{ $t("message.poorQuantity") }}:{{ items.inspect_num_diff }}
                  </p>
                  <!--  不良数 -->
                  <p>{{ $t("message.adverseNumber") }}:{{ items.inspect_bad_num }}</p>
                </div>
              </li>
            </ul>
            <!-- 箱子列表 -->
            <div class="box">
              <div class="box-title">
                <!-- 当前订单装箱中 -->
                <div class="title-item" :class="{ status: item.i == 0 }" @click="getStatus(item, index, 0)">
                  {{ $t("message.theCurrentOrderIsInBox") }}
                </div>
                <!-- 当前订单已装箱 -->
                <div class="title-item" :class="{ status: item.i == 1 }" @click="getStatus(item, index, 1)">
                  {{ $t("message.theCurrentOrderHasBeenBoxed") }}
                </div>
                <!-- 其他订单装箱中 -->
                <div class="title-item" :class="{ status: item.i == 2 }" @click="getStatus(item, index, 2)">
                  {{ $t("message.otherOrdersAreInBoxes") }}
                </div>
                <!-- 其他订单已装箱 -->
                <div class="title-item" :class="{ status: item.i == 3 }" @click="getStatus(item, index, 3)">
                  {{ $t("message.otherOrdersHaveBeenBoxed") }}
                </div>
              </div>
              <div class="box-list">
                <div class="item" v-for="items in item.boxList" :key="items.id">
                  <div class="item-box">
                    <el-checkbox v-model="items.checked" @change="$forceUpdate()"></el-checkbox>
                    <!--  -->
                    <div class="item-content" @click="lookBox(items.id)">
                      <div class="remark">
                        <el-tooltip effect="dark" :content="items.p_remark" placement="top">
                          <p>
                            NO{{ items.box_no }}：
                            <span> {{ items.p_remark }}</span>
                          </p>
                        </el-tooltip>
                      </div>
                      <div class="NO">
                        {{ items.weight }}kg_{{ items.attr }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <!-- 操作 -->
            <div class="operation-box">
              <div class="operation">
                <!-- 全选 -->
                <el-checkbox v-model="checked" @change="allChecked">{{
                  $t("message.allChecked")
                }}</el-checkbox>
                <!-- 箱子全选 -->
                <el-button type="success" size="small" @click="allBox(!boxChecked)">

                  {{ !boxChecked ? '箱子全选' : '箱子全选取消' }}</el-button>
                <!-- 添加新箱子 -->
                <el-button type="success" size="small" @click="addBoxDialogVisible = true" v-if="isAuth(185)">{{
                  $t("message.addNewChest")
                }}</el-button>
                <!-- 箱规修改 -->
                <el-button type="primary" size="small" class="primary" @click="boxGaugeModification(index)"
                  v-if="isAuth(185)">{{
                    $t("message.boxGaugeModification") }}</el-button>
                <!-- 重量修改 -->
                <el-button type="success" size="small" class="primary" @click="modificationOfWeigh(index)"
                  v-if="isAuth(185)">{{
                    $t("message.modificationOfWeigh") }}</el-button>
                <!-- 删除箱子 -->
                <el-button type="primary" size="small" class="dark" @click="delBox(index)" v-if="isAuth(186)">
                  {{ $t("message.delBox") }}</el-button>
                <!-- 标记装箱完了 -->
                <el-button type="primary" size="small" class="primary" @click="markPackingFinished(index)"
                  v-if="isAuth(187)">{{
                    $t("message.markPackingFinished") }}</el-button>
                <!-- 打印唛头 -->
                <el-button type="success" size="small" class="primary" @click="printingMarks(index, item)">{{
                  $t("message.printingMarks")
                }}</el-button>
                <!-- 取消已装箱 -->
                <el-button type="primary" size="small" class="dark" @click="cancellationOfPacking(index)"
                  v-if="isAuth(188)">{{
                    $t("message.cancellationOfPacking") }}</el-button>
                <!-- 装箱 -->
                <el-button type="primary" size="small" @click="encasement(index)" v-if="isAuth(189)">{{
                  $t("message.encasement") }}</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-dialog>
    <!-- 添加箱子 -->
    <addBox v-if="addBoxDialogVisible" :order_sn="boxData.order_sn" />
    <!-- 箱柜修改 -->
    <boxGaugeModification v-if="boxGaugeModificationDialogVisible" :ids="boxIds" />
    <!-- 重量修改 -->
    <modificationOfWeigh v-if="modificationOfWeighDialogVisible" :ids="boxIds" />
    <!-- 装箱 -->
    <encasement v-if="encasementDialogVisible" :boxList="boxList" :list="checkedList" />
    <!-- 包裹打印 -->
    <div v-show="false">
      <Printparcelinformation ref="Printparcelinformation" :datas="PrintparcelinformationData" v-if="show" />
    </div>
    <!-- 打印用户信息 -->
    <div v-show="false">
      <Customerinformation ref="Customerinformation" :userData="userData" />
    </div>
    <!-- 打印用户信息 -->
    <div v-show="false">
      <div ref="Finalshippingmark">
        <Finalshippingmark :detail="item" v-for="(item, index) in boxList" :key="index" />
      </div>
    </div>

    <!-- 物流号选择 -->
    <el-dialog :title="$t('message.logisticsNumberSelection')" :close-on-click-modal="false"
      :visible.sync="dialogVisible" width="320px" center>
      <div class="content">
        <el-select v-model="PrintparcelinformationData.express_no" placeholder="请选择" @change="$forceUpdate()">
          <el-option v-for="item in wuliuList" :key="item.express_no" :label="item.express_no" :value="item.express_no">
          </el-option>
        </el-select>
      </div>
      <span slot="footer" class="dialog-footer">
        <!--取 消  -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 打印 -->
        <el-button type="primary" @click="print">{{
          $t("message.print")
        }}</el-button>
      </span>
    </el-dialog>
    <!-- 箱子详情 -->
    <boxDetail :id="boxId" v-if="boxDialogVisible" />
    <!-- 库位选择 -->
    <warehouse v-if="warehouseDialogVisible" :shelf_type_set="shelf_type_set" :type="type" :boxIds="boxIds" />
  </div>
</template>
<script>
import detailHeader from "@/components/header/detailHeader";
import addBox from "@/components/box/addBox.vue";
import boxGaugeModification from "@/components/box/boxGaugeModification.vue";
import modificationOfWeigh from "@/components/box/modificationOfWeigh.vue";
import encasement from "@/components/box/encasement.vue";
import Printparcelinformation from "@/components/Printedsheet/Printparcelinformation";
import Customerinformation from "@/components/Printedsheet/Customerinformation";
import Finalshippingmark from '@/components/Printedsheet/Finalshippingmark.vue'
import boxDetail from './boxDetail/index'
import warehouse from "@/components/common/warehouse";
export default {
  components: {
    detailHeader,
    addBox,
    boxGaugeModification,
    modificationOfWeigh,
    encasement,
    Printparcelinformation,
    Customerinformation,
    Finalshippingmark,
    boxDetail,
    warehouse,
    boxId: 0,
  },
  metaInfo() {
    return {
      title: '直接装箱中',
    };
  },
  data() {
    return {
      checked: false,
      tableData: [],
      checkedList: [],
      boxList: [],
      index: 1,
      order_sn: "",
      boxIds: [], //箱子ID
      boxData: {}, //刷新列表箱子需要的数据
      addBoxDialogVisible: false, //添加箱子
      boxGaugeModificationDialogVisible: false, //箱柜修改
      modificationOfWeighDialogVisible: false, //重量修改
      encasementDialogVisible: false, //装箱
      PrintparcelinformationData: {
        express_no: ''
      }, //包裹打印信息
      show: false,
      dialogVisible: false,
      wuliuList: [],
      //打印用户信息
      userData: {},
      boxDialogVisible: false,//箱子详情
      boxChecked: false,// 箱子全选
      warehouseDialogVisible: false, //库位选择
      shelf_type_set: [], //可选货架类型
      type: '', //库位操作类型

    };
  },
  created() {
    this.upPreview();
  },
  methods: {
    upPreview() {

      let datas = {
        purchase_no: this.$route.query.purchase_no,
        express_no: this.$route.query.express_no,
        order_purchase_id_set: this.$route.query.order_purchase_ids
          ? this.$route.query.order_purchase_ids.split(",")
          : this.$parent.order_purchase_ids,
      };
      this.$api.inspectionApi.upPreview(datas).then((res) => {

        res.data.forEach((item, index) => {
          item.i = 0;
          item.list.forEach((items) => {
            items.checked = false;
            // items.maxUpNum = items.possible_num
            items.num = items.possible_num
          });
          item.boxList = [];
          this.getBoxList(0, item.order_sn, index);
        });
        this.tableData = res.data;
        this.$forceUpdate();
      });
    },
    // 获取箱子列表
    getBoxList(status, order_sn, index) {
      let datas = {
        status: status + 1,
        order_sn: order_sn,
      };
      this.$api.inspectionApi.boxList(datas).then((res) => {
        res.data.forEach((item) => {
          item.checked = false;
        });
        this.tableData[index].boxList = res.data;
        console.log(this.tableData[index].boxList);
        this.$forceUpdate();
      });
    },
    // 切换箱子状态
    getStatus(item, index, i) {
      this.tableData[index].i = i;
      this.getBoxList(i, item.order_sn, index);
      this.$forceUpdate();
    },
    //存更新箱子需要参数
    getboxData(item, index) {
      this.boxData = {
        i: item.i,
        order_sn: item.order_sn,
        index,
      };
    },
    // 刷新当前单号的箱子列表
    uploadBoxList() {
      this.getBoxList(
        this.boxData.i,
        this.boxData.order_sn,
        this.boxData.index
      );
    },
    // 单选
    changeItem() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
    },
    //  全选
    allChecked() {
      this.checkedList = [];
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = this.checked;
          if (items.checked) {
            this.checkedList.push(items);
          }
        });
      });
      this.$forceUpdate();
    },
    //取消全选
    cancelAllChecked() {
      this.checkedList = [];
      this.checked = false;
      this.tableData.forEach((item) => {
        item.list.forEach((items) => {
          items.checked = false;
        });
      });
      this.$forceUpdate();
    },
    // 是否显示商品列表
    isShow(i) {
      this.tableData[i].show = !this.tableData[i].show;
      this.$forceUpdate();
    },
    // 获取箱子id
    getBoxIds(i, data) {
      this.boxIds = [];
      this.boxList = [];
      this.tableData[i].boxList.forEach((item) => {
        if (item.checked) {
          if (data) {
            item.p_name = data.p_name
            item.y_name = data.y_name
            item.user = data.user
          }
          this.boxList.push(item);
          this.boxIds.push(item.id);
        }
      });
    },
    //修改箱柜
    boxGaugeModification(i) {
      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.boxGaugeModificationDialogVisible = true;
    },
    //重量修改
    modificationOfWeigh(i) {
      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.modificationOfWeighDialogVisible = true;
    },
    // 箱子删除
    delBox(i) {
      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inspectionApi
            .deleteBox({ ids: this.boxIds })
            .then((res) => {
              this.$message.success(res.msg);
              this.uploadBoxList();
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消操作",
          });
        });
    },
    // 标记装箱完了
    markPackingFinished(i) {
      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.getboxData(this.tableData[i], i);
      this.shelf_type_set = [1, 3];
      this.type = 11;
      this.warehouseDialogVisible = true;
    },
    // 选择库位并装箱完成后刷新当前箱子列表
    markPackingFinishedSuccess() {
      this.warehouseDialogVisible = false;
      this.uploadBoxList();
    },
    //取消已装箱
    cancellationOfPacking(i) {
      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$confirm(
        this.$t("message.areYouSureToReturnAfterPacking"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.ok"), //确定
          cancelButtonText: this.$t("message.cancel"), //取消
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.inspectionApi
            .toUnComplete({ ids: this.boxIds })
            .then((res) => {
              this.$message.success(res.msg);
              this.uploadBoxList();
            });
        })
        .catch(() => { });
    },
    // 装箱
    encasement(i) {
      if (this.checkedList == false)
        return this.$message.error(this.$t("message.selectableOperational"));
      this.checkedList.forEach((item) => {
        item.surplus = item.maxUpNum;
        item.num = item.maxUpNum;

        item.order_sn = this.tableData[0].order_sn;
      });

      this.getBoxIds(i);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.encasementDialogVisible = true;
    },
    // 最小数和最大数
    minMaxNum(i, is, item) {
      if (item.maxUpNum > item.possible_num) {
        this.tableData[i].list[is].maxUpNum = item.possible_num;
      }
      this.$forceUpdate();
    },
    // 装箱完成
    encasementSuccess() {
      this.upPreview();
      this.encasementDialogVisible = false;
    },
    //打印包裹信息
    printPackageInformation(item) {
      this.PrintparcelinformationData = item;
      this.wuliuList = item.order_purchase_express
      this.dialogVisible = true
      this.$forceUpdate()

    },
    //打印
    print() {
      this.show = true;
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$print(this.$refs.Printparcelinformation);
        this.dialogVisible = false
      });
    },
    //打印客户信息
    printCustomerInformation(item) {
      this.userData = item.user
      this.$forceUpdate()
      this.$nextTick(() => {
        this.$print(this.$refs.Customerinformation);
      });
    },
    //打印唛头
    printingMarks(i, item) {
      this.getBoxIds(i, item);
      if (this.boxIds == false)
        return this.$message.error(
          this.$t("message.aBoxWithNoSelectedOperation")
        );
      this.$nextTick(() => {
        this.$print(this.$refs.Finalshippingmark);

      });
    },
    //
    lookBox(id) {
      this.boxId = id
      this.boxDialogVisible = true
    },
    // 箱子全选
    allBox(checked) {
      this.boxChecked = checked

      this.tableData.forEach(item => {
        item.boxList.forEach(box => {
          box.checked = checked
        })
      })
      this.$forceUpdate()
    },
  },
};
</script>
<style lang='scss' scoped>
/deep/.el-checkbox__inner {
  transform: scale(2) !important;
}


.encasementDetail {
  background: #f8f8f8;
  border-radius: 0px 8px 8px 8px;
  padding: 24px;

}

.table {
  ol {
    display: flex;
    font-size: 14px;
    height: 60px;
    background-color: #edeff4;
    color: #333;
    position: sticky;
    top: 0px;
    left: 240px;
    z-index: 99;
    margin-bottom: 20px;

    li {
      display: flex;
      justify-content: center;
      align-items: center;
      line-height: 20px;
    }
  }

  ul {
    display: flex;
    border-bottom: 1px solid #e8e8e8;
    padding: 10px 0;
    font-size: 12px;
    transition: 0.25s;

    &:hover {
      background-color: #eee;
      cursor: pointer;
    }

    li {
      width: 100%;
      word-break: break-all;

      .template {
        width: 100%;
      }
    }

    .img {
      position: relative;

      img {
        width: 60px;
        height: 60px;
      }

      &:hover {
        .bigPic {
          display: block;
        }
      }

      .bigPic {
        position: absolute;
        right: -280px;
        top: -150px;
        z-index: 99;
        display: none;

        img {
          width: 300px;
          height: 300px;
        }
      }
    }

    /deep/.el-input {
      width: 100px;
    }
  }

  li {
    flex: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    text-align: center;
    padding: 0 3px;
  }

  .flex05 {
    flex: 0.5;
    position: relative;

    a {
      position: absolute;
      right: 0;
      top: 0;
      height: 20px;
      width: 20px;
      background-color: #f56c6c;
      border-radius: 50%;
      line-height: 20px;
      text-align: center;
      color: #fff;
    }

    label {
      width: 100%;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  .flex15 {
    flex: 1.3;
  }

  .flex2 {
    flex: 1.8;

    /deep/ .el-textarea__inner {
      height: 40px;
      padding: 0 2px;
      line-height: 18px;
    }
  }

  .itemDetail {
    .head {
      height: 60px;
      display: flex;
      background-color: #545467;
      font-size: 14px;
      color: #fff;

      a {
        color: #f0ef70;
      }

      .show {
        flex: 0.3;
        cursor: pointer;
        font-size: 30px;
        display: flex;
        justify-content: center;
        align-items: center;

        i {
          font-size: 16px;
        }
      }

      .item {
        flex: 1;
        line-height: 20px;
        padding: 10px;

        span {
          margin-right: 30px;
        }
      }

      .order {
        flex: 1.5;
      }

      .name {
        flex: 2;
        line-height: 40px;
      }

      .express_no-list {
        width: 20px;
        height: 20px;
        padding: 0;
        margin-left: 10px;

        /deep/.el-popper {
          background-color: pink !important;
        }
      }

      .lookRemark {
        flex: 2;
        text-align: right;
        line-height: 40px;
        margin-right: 14px;
      }
    }
  }

  .noData {
    padding: 20px 0;
    text-align: center;
  }
}

.box {
  border: 1px solid #edeff4;
  border-radius: 8px;
  margin-top: 24px;

  .box-title {
    padding: 17px 40px 0;
    display: flex;

    .title-item {
      padding: 15px 18px;
      font-size: 18px;
      cursor: pointer;
      border: 2px solid transparent;
    }

    .status {
      background: #f8f8f8;
      border: 1px solid #edeff4;
      border-top: 2px solid #2c96e7;
      border-top-color: #2c96e7;
      color: #2c96e7;
    }
  }

  .box-list {
    padding: 0 40px;
    background-color: #e8e8e8;
    display: flex;
    flex-wrap: wrap;

    .item {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 288px;
      border-right: 1px solid #edeff4;
      border-bottom: 1px solid #edeff4;
      padding: 20px 0;

      .item-box {
        display: flex;
        justify-content: center;
        align-items: center;

        /deep/.el-radio__input {
          transform: scale(1.5);
        }

        .el-checkbox {
          margin-right: 20px;
        }

        .item-content {
          padding: 15px;
          border: 1px solid #edeff4;
          border-radius: 4px;
          background-color: #fff;
          width: 178px;
          cursor: pointer;

          .remark {
            margin-bottom: 14px;

          }

          .NO {
            color: #999;
          }
        }
      }
    }
  }
}

.operation-box {
  margin-top: 24px;

  border-radius: 8px;
  position: sticky;
  bottom: 0;
  z-index: 9;

  .operation {
    background-color: #edeff4;
    padding: 16px 24px;

    .el-button {
      margin-left: 30px;
    }

    span {
      margin-left: 30px;
      font-size: 14px;
      cursor: pointer;
    }
  }
}
</style>
